import { Component, ComponentRef, Injector, OnDestroy, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActionWindowModel, ModalState } from '../../model/action-window-model';
import { ActionWindowService } from '../../service/action-window.service';

@Component({
    selector: 'app-action-window',
    templateUrl: './action-window.component.html',
    styleUrls: ['./action-window.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActionWindowComponent implements OnDestroy {
  constructor(
    private service: ActionWindowService,
    private container: ViewContainerRef
  ) {
    this._subscription = this.service.currentState.subscribe(data => this.updateState(data));
  }

  private _componentRef: ComponentRef<any>;
  private _subscription: Subscription;
  show: boolean;

  @ViewChild('modalHost', { read: ViewContainerRef }) host: ViewContainerRef;

  private updateState(data: any) {
    if (!data) throw new Error('Invalid operation.');

    if (data instanceof ActionWindowModel) {
      let injector = <Injector>data.injector;
      const providers = data.providers;
      this.dialogclass = data.wide ? 'dialog-box-w' : 'dialog-box';
      if (providers) injector = Injector.create({ providers: providers, parent: injector });
      this._componentRef = this.host.createComponent(data.component, { injector: injector, index: 0 });
      if (data.dataContext) this._componentRef.instance.dataContext = data.dataContext;
      this.show = true;
    } else if (data.state === ModalState.DESTROY || data.state === ModalState.CLOSE) {
      this.show = false;
      this.container.clear();
      if (this._componentRef) {
        this._componentRef.destroy();
        this._componentRef = null;
      }
    }
  }

  dialogclass = 'dialog-box';

  ngOnDestroy() {
    this._subscription.unsubscribe();
    if (this._componentRef) {
      this._componentRef.destroy();
      this._componentRef = null;
    }
  }
}
